import React, { Component } from 'react';
import AcaoRepasseVenda from './AcaoRepasseVenda';
import { tipoRepasseVenda } from '../../util/constantsUtil';

export class ItemRepasseVenda extends Component {

    render() {
        const { item, tipo } = this.props;
        const repasseEmpresa = tipo === tipoRepasseVenda.empresa.nome ? item.valorLiquido : '';
        const repasseVendedor = tipo === tipoRepasseVenda.vendedor.nome ? item.totalComissao : '';
        const repasseImposto = tipo === tipoRepasseVenda.imposto.nome ? item.totalImposto : '';
        return (
            <>
                {tipo === tipoRepasseVenda.empresa.nome && <div className="col">
                  <span className="titulo-mobile">Empresa:&nbsp;</span>{item.nomeEmpresa}
                </div>}

                {tipo === tipoRepasseVenda.vendedor.nome && <div className="col">
                  <span className="titulo-mobile">Vendedor:&nbsp;</span>{item.nomeUsuario}
                </div>}

                {tipo === tipoRepasseVenda.imposto.nome && <div className="col">
                  <span className="titulo-mobile">Grupo:&nbsp;</span>{item.grupo}
                </div>}

                
                <div className="col">
                    <span className="titulo-mobile">Total Taxa Servico R$:&nbsp;</span>
                    {Number(item.totalTaxaServico)
                        .toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                </div>
                <div className="col-auto mr-4">
                    <span className="titulo-mobile">Quantidade Total Reservas&nbsp;</span>
                    {item.quantidadeTotalReservas}
                </div>
                <div className="col">
                    <span className="titulo-mobile">Total Comissão R$:&nbsp;</span>
                    {Number(item.totalComissao)
                        .toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                </div>
                <div className="col">
                    <span className="titulo-mobile">Total Comissão Agente R$:&nbsp;</span>
                    {Number(item.totalComissaoAgente)
                        .toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                </div>

                <div className="col">
                    <span className="titulo-mobile">Total Imposto R$:&nbsp;</span>
                    {Number(item.totalImposto)
                        .toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                </div>
                <div className="col">
                    <span className="titulo-mobile">Total Custo Cancelamento R$:&nbsp;</span>
                    {Number(item.totalCustoCancelamento)
                        .toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                </div>
                <div className="col">
                    <span className="titulo-mobile">Total Faturado R$:&nbsp;</span>
                    {Number(item.valorTotalFaturadoReservas)
                        .toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                </div>
                {tipo === tipoRepasseVenda.empresa.nome ?
                <div className="col">
                    <span className="titulo-mobile">Líquido Empresa R$:&nbsp;</span>
                    {Number(item.valorLiquido)
                        .toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                </div> : ''}
                <div className="col">
                    <span className="titulo-mobile">Total Repasse R$:&nbsp;</span>                     
                    {Number(repasseEmpresa || repasseVendedor || repasseImposto)
                        .toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                </div>
                <div className="col">
                    <span className="titulo-mobile">Ações:&nbsp;</span>
                    <AcaoRepasseVenda repasseSelecionado={item}/>
                </div>
            </>
        )
    }

}